<template>
<div class="chapter">
<div class="inner_page">
<p class="C126"><a id="page_xxxi"></a><img alt="" height="auto" src="Images/image00224.jpeg" width="78%"/></p>
<p class="C108"><img alt="" height="auto" src="Images/image00225.jpeg" width="115%"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0011.vue?59836739